module.exports = __webpack_public_path__ + "img/md.a60a1301.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/md.jpg
// module id = 2203
// module chunks = 137